import React from 'react';

export default function ReferenceTile({ reference: r }) {
  // References are text citations unless an image has actually been generated for
  // them (r.src). Only then do we show an image frame; otherwise render a clean
  // citation row, not an empty placeholder box.
  const hasImage = !!r.src;
  const kind = (r.kind || 'REFERENCE').toUpperCase();
  return (
    <div className={`ref-tile ${hasImage ? '' : 'ref-citation'}`}>
      {hasImage && (
        <div className="ref-thumb">
          <img src={r.src} alt={r.source} />
          <span className="ref-kind">{kind}</span>
        </div>
      )}
      <div className="ref-body">
        <div className="ref-src">
          {!hasImage && <span className="ref-kind-tag">{kind}</span>}
          {r.source}
        </div>
        {r.purpose && <div className="ref-purpose">"{r.purpose}"</div>}
        {r.attribution && <div className="ref-att">VIA {r.attribution.toUpperCase()}</div>}
      </div>
    </div>
  );
}
